import {
  createFilterStore,
  FilterState,
  FilterStore,
} from "@faire/retailer-visitor-shared/components/Filters/FilterStore";
import * as React from "react";

export const FilterContext = React.createContext<FilterStore>(
  createFilterStore(FilterState.build(), { current: () => {} })
);
